import { render } from "./FrontPage.vue?vue&type=template&id=774c9759&scoped=true"
import script from "./FrontPage.vue?vue&type=script&lang=js"
export * from "./FrontPage.vue?vue&type=script&lang=js"

import "./FrontPage.vue?vue&type=style&index=0&id=774c9759&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-774c9759"]])

export default __exports__